<template>
  <div class="container p-0 card">
    <div class="header">
      <img src="@/assets/landing-page/assets/images/testimonial-header.svg" class="header-background" alt="image">
      <h1>Robin de Vries</h1>
      <h2>Product Lead at The Ocean Cleanup</h2>
    </div>
    <div class="content">
      <p>
        <strong>"</strong>Edgefirst Studio greatly reduced our dataset audit efforts and we have a very stable detection model in a few weeks.<strong>"</strong>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

</script>

<style lang="scss" scoped>
.card {
  box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  border: 2px solid #dcd9d9;
  overflow: hidden;
  max-width: 600px;
}

.header {
  position: relative;
  padding: 2rem;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.header h1, .header h2 {
  position: relative;
  z-index: 1;
}

.header h1 {
  font-size: 24px;
  color: var(--color-white-100);
}

.header h2 {
  font-size: 18px;
  font-weight: 500;
  color: var(--color-white-900);
}

.content {
  height: 100%;
  width: 100%;
  padding: 2rem;
  font-size: 18px;
  font-weight: 400;
  font-style: italic;
  text-align: left;
}
</style>
